export default __webpack_public_path__ + "static/media/IN.c1de4280.svg";